import React from 'react';
import { Link } from 'react-router-dom';
import RichText from '../ui/RichText';
import '../../css/common/HubSectionCard.css';

/**
 * Landing-page hub card — internal route, external URL, or path starting with http(s).
 */
const HubSectionCard = ({ card, className = 'section-card' }) => {
  const external = card.externalUrl || (card.path && /^https?:\/\//i.test(card.path));
  const href = card.externalUrl || card.path;
  const showImage = !!card.imageUrl;
  const showIcon = !showImage && card.icon;

  const inner = (
    <>
      {showImage ? (
        <img src={card.imageUrl} alt="" className="section-card-image" />
      ) : showIcon ? (
        <div className="section-icon">{card.icon}</div>
      ) : null}
      <h3 className="section-title">{card.title}</h3>
      {card.subtitle && <p className="section-subtitle">{card.subtitle}</p>}
      {card.description && <RichText value={card.description} className="section-description" />}
      <div className="section-arrow">{external ? '↗' : '→'}</div>
    </>
  );

  if (external) {
    return (
      <a
        href={href}
        className={className}
        target="_blank"
        rel="noopener noreferrer"
      >
        {inner}
      </a>
    );
  }

  return (
    <Link to={card.path} className={className}>
      {inner}
    </Link>
  );
};

export default HubSectionCard;
